// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--3ly_R";
export var inner = "styles-module--inner--1maEB";
export var content = "styles-module--content--3ZxUH";
export var header = "styles-module--header--VzJE3";
export var heading = "styles-module--heading--wqRXF";
export var readBlog = "styles-module--readBlog--29Lpk";